var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-x row"},[_c('div',{staticClass:"cell small-12 columns"},[_vm._v("\n\t\tEmpty\n\t")])])}]

export { render, staticRenderFns }